import { render, staticRenderFns } from "./student-score.vue?vue&type=template&id=11ff938e&"
import script from "./student-score.vue?vue&type=script&lang=js&"
export * from "./student-score.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports